import React from 'react'
import PageLayout from '../PageLayout'
import MapsTable from './MapsTable'

// const useStyles = makeStyles(theme => ({
//     content: {
//        //
//     },
// }))


export default function AppMapsPage() {
    // const classes = useStyles()

    // console.log('AppMapsPage render')

    return (
        <PageLayout>
            <MapsTable />
        </PageLayout>
    )
}

